import StudentProfile from "../../components/admin/StudentProfile";
import Profile from "../../components/student/Profile";

export default function StdHome(options) {
    return (
      <>
        <Profile/>
      </>
    );
}